const menuToggleBtn = document.querySelector('.header__toggle');
const menuDrawer = document.getElementById('mobileDrawer');
const menuCloseBtn = document.querySelector('.drawer-close');

const cartToggleBtn = document.querySelector('.header__icons a[href="{{ routes.cart_url }}"]'); // cart icon link
const cartDrawer = document.getElementById('cartDrawer');
const cartCloseBtn = document.querySelector('.cart-close');

// Menu drawer toggle
if(menuToggleBtn && menuDrawer){
  menuToggleBtn.addEventListener('click', ()=> menuDrawer.classList.add('open'));
}
if(menuCloseBtn){
  menuCloseBtn.addEventListener('click', ()=> menuDrawer.classList.remove('open'));
}

// Cart drawer toggle
if(cartToggleBtn && cartDrawer){
  cartToggleBtn.addEventListener('click', function(e){
    e.preventDefault(); // prevent default cart page navigation
    cartDrawer.classList.add('open');
  });
}
if(cartCloseBtn){
  cartCloseBtn.addEventListener('click', ()=> cartDrawer.classList.remove('open'));
}